import { useEffect } from "react";
import { card } from "./AppShell";
import { Button } from "./Button";

// A small in-app confirmation modal (never window.confirm). Modelled on the fullscreen lightbox overlay
// in VisualizePage. Renders nothing when closed; Escape and the scrim both cancel.
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Remove",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
}: {
  open: boolean;
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onCancel(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div
      onClick={onCancel}
      style={{ position: "fixed", inset: 0, zIndex: 1100, background: "rgba(15,23,42,0.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        data-testid="confirm-dialog"
        onClick={(e) => e.stopPropagation()}
        style={{ ...card, maxWidth: 360, width: "100%" }}
      >
        <h3 style={{ margin: "0 0 6px", fontSize: 17 }}>{title}</h3>
        {message && <p style={{ margin: "0 0 16px", color: "var(--muted)", fontSize: 14 }}>{message}</p>}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: message ? 0 : 12 }}>
          <Button variant="secondary" size="sm" onClick={onCancel} data-testid="confirm-no">{cancelLabel}</Button>
          <Button
            variant="primary"
            size="sm"
            onClick={onConfirm}
            data-testid="confirm-yes"
            style={{ background: "var(--danger)", borderColor: "var(--danger)", color: "#fff" }}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
